<template>
    <div>뷰x</div>
</template>

<script>
    export default {
        name: "NoticeView"
    }
</script>

<style scoped>

</style>